import { ClustersPage } from "@/components/ClustersPage";
export default function Page() { return <ClustersPage wing="social" />; }
